import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@workos-inc/authkit-react";
import { MainComponent } from "./MainComponent";
import { LayoutProvider } from "../../context/LayoutContext";
import { BodycamContextProvider } from "../../context/BodycamContext";
import { useJobStore } from "../../store/jobStore";
import { Box, CircularProgress } from "@mui/material";

export function ProtectedView({ children }: { children: React.ReactNode }) {
  const { user, isLoading } = useAuth();
  const navigate = useNavigate();
  const clearStore = useJobStore((state) => state.clearStore);
  const hasRedirected = useRef(false);

  useEffect(() => {
    if (isLoading) return;

    if (!user && !hasRedirected.current) {
      hasRedirected.current = true;
      console.warn("[ProtectedView] Not authenticated, redirecting to login");
      clearStore();
      navigate("/login", { replace: true });
    }
  }, [isLoading, user, clearStore, navigate]);

  // Reset the redirect guard if user becomes authenticated
  useEffect(() => {
    if (user) {
      hasRedirected.current = false;
    }
  }, [user]);

  if (isLoading || !user) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <BodycamContextProvider>
      <LayoutProvider>
        <MainComponent>{children}</MainComponent>
      </LayoutProvider>
    </BodycamContextProvider>
  );
}
